import React, { useEffect, useState, useRef, memo } from "react";
import { useNavigate } from "react-router-dom";

//js
import { UseDepartment } from "../../../Js/Context/DepartmentCntx";
import { UseUser } from "../../../Js/Context/userCntx";
import { CallService, modalAlert, getAllCompany } from "../../../Js/Script";
import { UseTicket, SetTicket } from "../../../Js/Context/TicketCntx";
import { UseOrganizaton } from "../../../Js/Context/OrganizationCntx";
//material-ui
import Autocomplete from "@mui/material/Autocomplete";
import { TextField } from "@mui/material";
const TransferTicket = memo(function TransferTckt(props) {
  const navigate = useNavigate();
  const { showTransferTicketComponent, ticketId } = props;
  const stDepartments = UseDepartment();
  const stOrganization = UseOrganizaton();
  const setTicket = SetTicket();
  const stUser = UseUser();

  const [states, setStates] = useState({
    ToTheGroup: "",
    ToTheGroupAutoCompleteData: "",
    User: "",
    UserAutoCompleteData: "",
    Message: "",
    department: "",
  });
  const inputRefs = {
    dvTransferTicket: useRef(null),
  };
  const { setShowTransferTicketComponent } = props;
  const handleToTheGroupChange = (event) => {
    setStates((prevState) => ({
      ...prevState,
      ToTheGroup: event.target.object,
    }));
  };
  function submitTransferTicket(e, id) {
    var data = {
      message: states.Message == "" ? null : states.Message,
      AssignerUserId: states.User.userId,
      regUserId : localStorage.getItem("id")
    };
    CallService(`tickets/${id}/transferticket`, data, "PUT", false, false)
      .then((res) => {
        setTicket((prevState) => ({
          ...prevState,
          ShowSuccessTxt: {
            show: true,
            txt: `ارجاع تیکت با شناسه ${id} با موفقیت انجام شده است`,
          },
        }));
        navigate(-1);
      })
      .catch((err) => {
        modalAlert(err.message, "خطا");
      });
  }
  useEffect(() => {
    setTimeout(() => {
      if (
        inputRefs.dvTransferTicket.current.classList.contains(
          "dvTransferTicket-show"
        )
      ) {
        inputRefs.dvTransferTicket.current.classList.remove(
          "dvTransferTicket-show"
        );
      } else {
        inputRefs.dvTransferTicket.current.classList.add(
          "dvTransferTicket-show"
        );
      }
    }, 900);
  }, [showTransferTicketComponent]);
  return (
    <div
      className={`panel dvTransferTicket-hide ${
        showTransferTicketComponent ? "" : "dvTransferTicket-show"
      }`}
      ref={inputRefs.dvTransferTicket}
    >
      <div className="panel-heading flexRow">test </div>
      <div className="p-0-100">
        <div className="newTicket-inputGroup">
          <span className="newTicket-span">*به دپارتمان/گروه :</span>
          {/*{states.ToTheGroupAutoCompleteData && (*/}
          <Autocomplete
            disablePortal
            options={getAllCompany(stDepartments, stOrganization)}
            getOptionLabel={(options) => {
              return options.title;
            }}
            renderInput={(params) => (
              <TextField
                className="damage-type-input font-family-ticket-input"
                {...params}
                InputProps={{
                  ...params.InputProps,
                }}
                required
              />
            )}
            renderOption={function (props, option) {
              return <li {...props} className="font-family-ticket">
                 <span className="font-family-ticket">{option.title}</span>
                </li>;
            }}
            value={states.department || null}
            onChange={(e, newValue) => {
              setStates((prev) => ({
                ...prev,
                department: newValue ? newValue : null,
              }));
            }}
          />
          {/*)}*/}
        </div>
        <div className="newTicket-inputGroup">
          <span className="newTicket-span">*کاربر:</span>
          {/*{states.UserAutoCompleteData && (*/}
          <Autocomplete
            disablePortal
            options={
              stUser
                ? stUser.filter(
                    (user) =>
                      (user.referenceId ===
                        states["department"].organizationId &&
                        user.referenceType === true) ||
                      (user.referenceId === states["department"].departmentId &&
                        user.referenceType === false)
                  )
                : null
            }
            getOptionLabel={(options) => {
              if (options) {
                return options.firstName + " " + options.lastName;
              } else {
                return "";
              }
            }}
            renderInput={(params) => (
              <TextField
                className="damage-type-input font-family-ticket-input"
                {...params}
                InputProps={{
                  ...params.InputProps,
                }}
                required
              />
            )}
            renderOption={function (props, option) {
              return (
                <li {...props}> <span className="font-family-ticket">{option.firstName + " " + option.lastName}</span></li>
              );
            }}
            value={states.User || ""}
            onChange={(e, newValue) => {
              setStates((prev) => ({
                ...prev,
                User: newValue ? newValue : null,
              }));
            }}
          />
          {/*)}*/}
        </div>
        <div className="newTicket-inputGroup">
          <span className="newTicket-span"> پیغام :</span>
          <textarea
            style={{ height: "111px" }}
            className="input-group-text font-family-ticket"
            onChange={(event) => {
              setStates((prevState) => ({
                ...prevState,
                Message: event.target.value,
              }));
            }}
          ></textarea>
        </div>
        <div>
          <button
            className="btn-success"
            onClick={(e) => {
              submitTransferTicket(e, ticketId);
            }}
          >
            انتقال
          </button>
          <button
            className="outBtn"
            onClick={() => {
              inputRefs.dvTransferTicket.current.classList.remove(
                "dvTransferTicket-show"
              );
              setShowTransferTicketComponent(false);
            }}
          >
            انصراف
          </button>
        </div>
      </div>
    </div>
  );
});
export default TransferTicket;
